export const convertHeaderRelativeInput = (input: string | Request) => {
    const url = typeof input === "string" ? input : input.url;
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;
    const tld = hostname.substring(hostname.lastIndexOf("."));
    const path = urlObj.pathname;
    const search = urlObj.search;
    const newUrl = new URL(`https://rynekpierwotny${tld}${path}${search}`);

    if (typeof input !== "string") {
        return new Request(newUrl.toString(), input);
    } else {
        return newUrl;
    }
};
export const convertHeaderRelativeInput = (input: string | Request) => {
    const url = typeof input === "string" ? input : input.url;
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;
    const tld = hostname.substring(hostname.lastIndexOf("."));
    const path = urlObj.pathname;
    const search = urlObj.search;
    const newUrl = new URL(`https://rynekpierwotny${tld}${path}${search}`);

    if (typeof input !== "string") {
        return new Request(newUrl.toString(), input);
    } else {
        return newUrl;
    }
};
